import { getNavigationTabCommand } from 'src/constants/appShortcuts';

export type NavigationPane = 'home' | 'search' | 'settings' | 'inbox' | 'sidekick';

export type NavGroupTabId = NavigationPane;

/** Assigns Control 1…N by left-to-right visible order in the grouping-tab strip. */
export const getVisibleNavGroupTabShortcuts = (
  tabs: readonly { id: NavGroupTabId; show: boolean }[],
): Partial<Record<NavGroupTabId, string>> => {
  const shortcuts: Partial<Record<NavGroupTabId, string>> = {};
  let slot = 1;
  for (const tab of tabs) {
    if (!tab.show) {
      continue;
    }
    shortcuts[tab.id] = getNavigationTabCommand(slot);
    slot += 1;
  }
  return shortcuts;
};
